import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  InputSlider,
  Label,
  Spacer
} from '@directsoftware/ui-kit-web-admin';
import { useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import { selectListingsSearchState } from '../../../redux/slices/listingsSearch';
import { formatCurrency } from '../../../../shared/helpers';

const ListingsSearchPrice = ({ updateSearchState }) => {
  const searchState = useSelector(selectListingsSearchState);
  const [filterPriceLow, setFilterPriceLow] = useState(
    searchState.filter_priceLow ?? searchState.min_price
  );
  const [filterPriceHigh, setFilterPriceHigh] = useState(
    searchState.filter_priceHigh ?? searchState.max_price
  );
  const brand = useSelector(state => state.brand);

  // While no explicit price filter is set, keep the handles pinned to the
  // current catalog bounds. Other filters (dates, guests) shift the catalog
  // price range, and without this the handle value drifts out of sync with the
  // min/max scale and appears to jump.
  useEffect(
    () => {
      if (
        (searchState.filter_priceLow === null ||
          searchState.filter_priceLow === undefined) &&
        (searchState.filter_priceHigh === null ||
          searchState.filter_priceHigh === undefined)
      ) {
        setFilterPriceLow(searchState.min_price);
        setFilterPriceHigh(searchState.max_price);
      }
    },
    [
      searchState.min_price,
      searchState.max_price,
      searchState.filter_priceLow,
      searchState.filter_priceHigh
    ]
  );

  const updateSearch = filterState => {
    setFilterPriceLow(filterState.filter_priceLow);
    setFilterPriceHigh(filterState.filter_priceHigh);

    debouncedUpdateSearchState(filterState);
  };

  const debouncedUpdateSearchState = useCallback(
    debounce(
      (filterState) => {
        updateSearchState(filterState, true);
      },
      300
    ),
    []
  );

  useEffect(() => {
    if (
      searchState.filter_priceLow == null &&
      searchState.filter_priceHigh == null
    ) {
      debouncedUpdateSearchState.cancel();
      setFilterPriceLow(searchState.min_price);
      setFilterPriceHigh(searchState.max_price);
    }
  }, [
    searchState.filter_priceLow,
    searchState.filter_priceHigh,
    searchState.min_price,
    searchState.max_price
  ]);

  return (
    searchState.max_price &&
    searchState.min_price !== null && (
      <Box paddingBottom="xs">
        <Label>Price</Label>
        <Spacer size="xxs" />
        <InputSlider
          isRange
          showRangeMinMax
          customColor={brand.brand_info.colors?.color_primary}
          onChange={value => {
            updateSearch(
              {
                filter_priceLow: value[0],
                filter_priceHigh: value[1]
              }
            );
          }}
          min={searchState.min_price}
          max={searchState.max_price}
          minDisplay={formatCurrency(
            filterPriceLow,
            brand.currency,
            null,
            true
          )}
          maxDisplay={formatCurrency(
            filterPriceHigh,
            brand.currency,
            null,
            true
          )}
          value={[filterPriceLow, filterPriceHigh]}
        />
      </Box>
    )
  );
};

export default ListingsSearchPrice;
